import React, {useEffect, useRef, useState} from 'react';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Password} from "primereact/password";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import GeneralUtils from "../../utils/GeneralUtils";
import {Link, useNavigate} from "react-router-dom";
import {AUTHORIZATION_HEADER, SERVER_URL} from "../../utils/Constants";
import SHA256 from "crypto-js/sha256";
import { Card } from 'primereact/card';
import ReCAPTCHA from 'react-google-recaptcha';
import SystemParameterService from "../../service/SystemParameterService";

const Login = (props) => {
    const {setIsAuthenticated, setIsInstructor} = props;
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [doesSystemWorkInLiveMode, setDoesSystemWorkInLiveMode] = useState(null);
    const [reCaptchaToken, setReCaptchaToken] = useState(null);
    const reCAPTCHA = useRef(null);
    const systemParameterService = new SystemParameterService();
    const navigate = useNavigate();

    useEffect(() => {
        if (reCAPTCHA.current) {
            reCAPTCHA.current.reset();
        }
        systemParameterService.doesSystemWorkInLiveMode().then(response => {
            setDoesSystemWorkInLiveMode(response);
            if (response) {
                setReCaptchaToken(false);
            } else {
                setReCaptchaToken(true);
            }
        });
    }, []);

    const login = () => {
        if (GeneralUtils.isNullOrEmpty(email) || GeneralUtils.isNullOrEmpty(password)) {
            return toast.warn("E-posta adı veya şifresi boş olamaz!");
        }

        fetch(SERVER_URL + 'login', {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                email: email,
                password: SHA256(password).toString(),
                "reCaptchaToken": reCaptchaToken
            })
        }).then(response => {
                if (response.ok) {
                    response.json().then(response => {
                        localStorage.setItem(AUTHORIZATION_HEADER, response.token);
                        localStorage.setItem("uUser", JSON.stringify(response.uUser));
                        localStorage.setItem("isAuthenticated", true);
                        localStorage.setItem("isInstructor", response.uUser.isInstructor);
                        // localStorage.setItem("privilegeList", JSON.stringify(GeneralUtils.getPrivilegeListFromRoleList()));
                        setIsAuthenticated(true);
                        setIsInstructor(response.uUser.isInstructor);
                        navigate('/');
                        // window.location.reload();
                    })
                } else {
                    setEmail('');
                    setPassword('');
                    GeneralUtils.notification(response);
                }
            }
        ).catch(error => {
            GeneralUtils.notification(error);
        });

    };

    return (
        <div className="flex flex-column align-items-center justify-content-center" style={{margin: "5rem 0 5rem"}}>
            <div style={{
                    borderRadius: '56px',
                    padding: '0.3rem',
                    background: 'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)'
                }}>
            <Card className="w-full surface-card py-8 px-5 sm:px-8" style={{ borderRadius: '53px' }} title="Hesabınızda oturum açın">
            <div className="flex flex-column gap-4" style={{padding: "2rem", width: "500px"}}>
                <InputText value={email} onChange={(e) => setEmail(e.target.value)} keyfilter="email"
                           className="inputtext p-inputtext-sm" placeholder="E-posta adresi girin"/>
                <Password value={password} onChange={(e) => setPassword(e.target.value)} feedback={false} toggleMask
                          className="p-inputtext-sm" placeholder="Mevcut şifreyi girin"/>
                {doesSystemWorkInLiveMode &&
                    <span style={{alignItems: 'center'}}>
                                <ReCAPTCHA
                                    ref={reCAPTCHA}
                                    hl="tr"
                                    size="normal"
                                    sitekey="6Lep9qIUAAAAAHk6E9GINxi8JKbHK7m9yIQTloQ_"
                                    onChange={(reCaptchaToken) => setReCaptchaToken(reCaptchaToken)}/>
                            </span>
                }
                <Button label="Oturum aç" onClick={login} size="sm" style={{width: "100%"}} disabled={!reCaptchaToken}/>


                <p>Hesabınız yok mu? <Link to={`/signup`} style={{color: 'var(--highlight-text-color)', fontWeight: "600"}}>Kaydolun</Link></p>

            </div>
            </Card>
            </div>
        </div>

    );
}

export default Login;